/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

import {ContactId, ContactInput} from "../__ignore/schemas";

/**
 * @summary Edit representative contact
 */
export const EditRepresentativeContactBody = ContactInput;

export const EditRepresentativeContactResponse = zod.void();

/**
 * @summary Remove representative contact
 */
export const RemoveRepresentativeContactResponse = zod.void();

/**
 * @summary Add representative contact
 */
export const AddRepresentativeContactBody = ContactInput;

export const AddRepresentativeContactResponse = ContactId;
